import { publicRequest } from "./http.service";
import { fullPageStart, fullPageStop } from "../slice/loader.slice";
import { loginSuccess, loginFailure } from "../slice/authSlice";
import { toast } from 'react-toastify';
import { userRequest } from "./http.service";


export const doLogin = async (dispatch, data, actions) => {
   dispatch(fullPageStart());
  // Remove old token if exists
  localStorage.removeItem('token');
  try {
    const response = await publicRequest.post("/admin/login", data);
     if(response?.data?.success === true) {
       dispatch(loginSuccess(response?.data?.user));
      const jwtToken = response?.data?.token;
      
      // Save token to localStorage
      if (jwtToken) {
        localStorage.setItem('token', jwtToken);
        console.log("Token saved successfully:", jwtToken);
      } else {
        console.error("No token received from server");
        toast.error("Login failed: No token received");
        dispatch(loginFailure());
        return;
      }
      
      toast.success("Login successful");
      
      // Small delay to ensure token is saved before navigation
      setTimeout(() => {
        // Navigation will be handled by useEffect in Login component
      }, 100);
    } else {
      dispatch(loginFailure()); 
      toast.error(response?.data?.message || "Invalid authentication");
    }
  } catch (err) {
    console.error(err, "Login Service failed");
    dispatch(loginFailure());
    toast.error(err?.response?.data?.message || "Request Unreachable");
  } finally {
    dispatch(fullPageStop());
    actions.setSubmitting(false);
  }
};

export const Sendmail = async (email) => {
  try {
    const response = await publicRequest.post("/password-reset", email );
    if (response.data.status === "SUCCESS") {
      toast.success("Mail Sent Successfully")
      return response.data;
    };
    if (response.data.status !== "SUCCESS") {
      toast.error(response.data.message)
    }
  } catch (err) {
    console.error(err, "Service failed");
  } finally {
  }
};

export const setPassword = async (data) => {
  try {
    const response = await publicRequest.post(`/resetpassword`, data);
    if (response.data.status === "SUCCESS") {
      toast.success("Password Reset Success")
      return response.data;
    };
    if (response.data.status !== "SUCCESS") {
      toast.error(response.data.message)
    }
  } catch (err) {
    console.error(err, "Service failed");
  } finally {
  }
};

export const viewProfile = async (_id, dispatch) => {
  dispatch(fullPageStart());
  try {
    const response = await userRequest.get(`/view-user/${_id}`);
    return response.data;
  } catch (err) {
    console.error(err, "Service failed");
  } finally {
    dispatch(fullPageStop());
  }
};

export const getSearchUsers = async (key, data, dispatch) => {
  dispatch(fullPageStart())
  try {
    const response = await userRequest.post(`/searchUser/${key}`, data);
    return response.data;
  } catch (err) {
    console.error(err, "Service failed");
  } finally {
    dispatch(fullPageStop())
  }
};

export const updateProfile = async (_id, formData, dispatch) => {
  dispatch(fullPageStart());
  try {
    const response = await userRequest.put(`update-user/${_id}`, formData);
    if (response.data.status === "SUCCESS") {
      toast.success("Profile Updated Successfully")
      return response.data;
    };
    if (response.data.status !== "SUCCESS") {
      toast.error("ERROR")
    }
  } catch (err) {
    console.error(err, "Service failed");
  } finally {
    dispatch(fullPageStop());

  }
};

export const logLastActivity = async (last_activity) => {
  try {
    await userRequest.post(
      "/last-activity",
      { last_activity }
    );
    return true;
  } catch (err) {
    return false;
  }
}

export const logoutUser = async () => {
  return await userRequest.get("/admin/logout",{});
}

export const passwordReset = async (formData) => {
  return await userRequest.put(`/admin/password/reset`,formData);
}


export const compareUserMetrics = async (formData) => {
  return await userRequest.post(`/admin/user-metrics-compare`,formData);
}